/**
 * @ Author: Housefolios
 * @ Create Time: 2021-12-16 11:36:56
 * @ Modified by: David Helmick
 * @ Modified time: 2025-08-12 19:47:57
 * @ Description: Component to handle signins from external sites
 */

import React, { useEffect } from 'react'
import { gql } from '@apollo/client'
import { useMutation } from '@apollo/client/react'

// Centralized lodash imports - much cleaner!
import { includes, map } from '@/utils/lodash'

import BlockUi from 'react-block-ui'
import { PacmanLoader } from 'react-spinners'
import { Box } from '@mui/material'

const EXTERNAL_SIGN_IN = gql`
  mutation externalSignIn(
    $identifier: String!
    $userInput: userInput!
    $memberField: String
    $memberRole: String
    $subscriptionType: String
  ) {
    externalSignIn(
      identifier: $identifier
      userInput: $userInput
      memberField: $memberField
      memberRole: $memberRole
      subscriptionType: $subscriptionType
    ) {
      token
      reset
    }
  }
`

const hostName = import.meta.env.VITE_HOSTNAME

const ExternalSignIn = (props) => {
  const [externalSignIn] = useMutation(EXTERNAL_SIGN_IN)

  useEffect(() => {
    let referrer =
      import.meta.env.VITE_HOSTNAME === 'app.housefolios.com'
        ? props.referrer
        : props.testReferrer
    let windowUrl = window.location.search
    const params = new URLSearchParams(windowUrl)
    let firstname = params.get('first_name')
    let lastname = params.get('last_name')
    let email = params.get('email')
    let identifier = params.get('token')
    let member = params.get('member')
    let subscriptionType = params.get('subscription_type')
    // console.log(
    //   'email',
    //   email,
    //   'first_name',
    //   firstname,
    //   'last_name',
    //   lastname,
    //   'identifier',
    //   identifier,
    // )
    // let password = (
    //   Math.random()
    //     .toString(36)
    //     .replace(/[^a-z]+/g, '') + '00000000000000000'
    // ).substr(0, 15)
    let password = email + identifier
    //if (includes(referrer, document.referrer) || includes(map(referrer, ref => ref+'/'), document.referrer)) {
    if (!identifier) window.location.replace(document.referrer)
    else {
      externalSignIn({
        variables: {
          userInput: {
            profile: {
              firstname,
              lastname,
            },
            email,
            password,
          },
          identifier,
          memberField: member,
          subscriptionType,
        },
      })
        .then(async ({ data  }) => {
          if (data.externalSignIn.reset) {
            props.navigate(
              `/resetpassword/${data.externalSignIn.token}`,
            )
          } else {
            localStorage.setItem('token', data.externalSignIn.token)
            localStorage.setItem('trialBanner', 'true')
            if (data && data.externalSignIn) {
              if (data.externalSignIn.member)
                document.cookie = `SourceSignUp=${data.externalSignIn.member}; expires=Wed, 31 Dec 2025 12:00:00 UTC;`
            }
            props.refetch()
          }

          // props.history.push('/')
        })
        .catch((error) => {
          console.log(error)
        })
    }
    //}
  }, [props])

  return (
    <Box sx={{ minHeight: '100vh', height: '100vh' }}>
      <BlockUi
        blocking={true}
        loader={
          <PacmanLoader color={'var(--primary)'} loading={true} />
        }
        message={<Box sx={{ color: '#368cff' }}>Verifying User</Box>}
      />
    </Box>
  )
}

export default ExternalSignIn
